'use client';

import { usePathname } from 'next/navigation';
import useSWRImmutable from 'swr/immutable';
import { getPathnameFromHeader } from '@/helpers/common';
import { fetcherCMS } from '@/modules/api';
import {
  getSeoContentUrl,
  type ISeoContentResponse,
  mapSeoContent,
  type SeoContentResult,
} from './shared';

const fetchSeoContent = async (url: string) => {
  const response = await fetcherCMS<ISeoContentResponse[] | null>(url);

  return mapSeoContent(response?.[0]);
};

export const useSeoContent = (
  locale: string,
  initialPath: string,
  initialData: SeoContentResult | null | undefined
) => {
  const pathname = usePathname();
  const routePath = getPathnameFromHeader(pathname, locale);

  const { data } = useSWRImmutable<SeoContentResult | null>(
    getSeoContentUrl(locale, routePath),
    fetchSeoContent,
    { fallbackData: routePath === initialPath ? initialData : undefined }
  );

  return { routePath, seoContent: data ?? null };
};
